
import { useState } from 'react';

export default function FiverrSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const fiverrProjects = [
    {
      title: 'E-commerce Sales Funnel',
      client: 'Fashion Brand',
      revenue: '$2.3M',
      conversion: '18.5%',
      image: 'https://readdy.ai/api/search-image?query=E-commerce%20sales%20funnel%20interface%20showing%20fashion%20products%2C%20shopping%20cart%20flow%2C%20modern%20online%20store%20design%2C%20conversion%20optimization%20elements%2C%20professional%20web%20design%2C%2016:9%20aspect%20ratio%20with%20Cofunnels%20watermark&width=500&height=281&seq=fiverr-ecommerce-001&orientation=landscape',
      description: 'Complete e-commerce funnel with product pages, cart abandonment sequences, and upsell flows.',
      link: 'https://fiverr.com/cofunnels/ecommerce-funnel'
    },
    {
      title: 'Lead Generation Funnel',
      client: 'SaaS Company',
      revenue: '$1.8M',
      conversion: '24.2%',
      image: 'https://readdy.ai/api/search-image?query=SaaS%20lead%20generation%20funnel%20showing%20software%20demo%20signup%2C%20professional%20dashboard%20interface%2C%20modern%20tech%20design%2C%20conversion%20forms%2C%20clean%20business%20layout%2C%2016:9%20aspect%20ratio%20with%20Cofunnels%20watermark&width=500&height=281&seq=fiverr-saas-001&orientation=landscape',
      description: 'High-converting lead gen funnel with free trial signup and automated nurture sequences.',
      link: 'https://fiverr.com/cofunnels/lead-generation'
    },
    {
      title: 'Webinar Registration Funnel',
      client: 'Online Course Creator',
      revenue: '$950K',
      conversion: '31.7%',
      image: 'https://readdy.ai/api/search-image?query=Webinar%20registration%20funnel%20interface%2C%20online%20course%20marketing%20page%2C%20educational%20content%20layout%2C%20signup%20forms%2C%20professional%20learning%20platform%20design%2C%2016:9%20aspect%20ratio%20with%20Cofunnels%20watermark&width=500&height=281&seq=fiverr-webinar-001&orientation=landscape',
      description: 'Complete webinar funnel with registration, reminder sequences, and course sales.',
      link: 'https://fiverr.com/cofunnels/webinar-funnel'
    },
    {
      title: 'Service Business Funnel',
      client: 'Digital Agency',
      revenue: '$3.2M',
      conversion: '22.8%',
      image: 'https://readdy.ai/api/search-image?query=Digital%20agency%20service%20funnel%20showing%20consultation%20booking%2C%20service%20packages%2C%20professional%20business%20website%2C%20contact%20forms%2C%20modern%20agency%20design%2C%2016:9%20aspect%20ratio%20with%20Cofunnels%20watermark&width=500&height=281&seq=fiverr-agency-001&orientation=landscape',
      description: 'Service-based funnel with consultation booking and automated client onboarding.',
      link: 'https://fiverr.com/cofunnels/service-funnel'
    },
    {
      title: 'Product Launch Funnel',
      client: 'Tech Startup',
      revenue: '$1.5M',
      conversion: '19.3%',
      image: 'https://readdy.ai/api/search-image?query=Product%20launch%20funnel%20showing%20countdown%20timer%2C%20pre-launch%20signup%2C%20modern%20startup%20website%20design%2C%20product%20showcase%2C%20tech%20innovation%20layout%2C%2016:9%20aspect%20ratio%20with%20Cofunnels%20watermark&width=500&height=281&seq=fiverr-launch-001&orientation=landscape',
      description: 'Pre-launch funnel with countdown timers, early bird offers, and launch sequences.',
      link: 'https://fiverr.com/cofunnels/product-launch'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % fiverrProjects.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + fiverrProjects.length) % fiverrProjects.length);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Featured Fiverr Projects
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Real results from our Fiverr clients - see the funnels that generated millions in revenue
          </p>
          <div className="flex justify-center">
            <a 
              href="https://fiverr.com/cofunnels" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors duration-300 font-medium whitespace-nowrap"
            >
              <i className="ri-external-link-line mr-2"></i>
              View Our Fiverr Profile
            </a>
          </div>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-8 overflow-hidden">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div className="relative">
                <img 
                  src={fiverrProjects[currentSlide].image} 
                  alt={fiverrProjects[currentSlide].title}
                  className="w-full h-64 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
              
              <div>
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full">
                    {fiverrProjects[currentSlide].client}
                  </span>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {fiverrProjects[currentSlide].title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {fiverrProjects[currentSlide].description}
                </p>
                
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="text-center p-4 bg-white rounded-lg">
                    <div className="text-2xl font-bold text-green-600">
                      {fiverrProjects[currentSlide].revenue}
                    </div>
                    <div className="text-sm text-gray-600">Revenue Generated</div>
                  </div>
                  <div className="text-center p-4 bg-white rounded-lg">
                    <div className="text-2xl font-bold text-blue-600">
                      {fiverrProjects[currentSlide].conversion}
                    </div>
                    <div className="text-sm text-gray-600">Conversion Rate</div>
                  </div>
                </div>
                
                <a 
                  href={fiverrProjects[currentSlide].link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 font-medium whitespace-nowrap"
                >
                  <i className="ri-external-link-line mr-2"></i>
                  View on Fiverr
                </a>
              </div>
            </div>
          </div>

          {/* Navigation buttons */}
          <button 
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-xl text-gray-600"></i>
          </button>
          
          <button 
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-xl text-gray-600"></i>
          </button>

          {/* Dots indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {fiverrProjects.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors duration-200 cursor-pointer ${
                  index === currentSlide ? 'bg-blue-600' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
